import React from "react";
import { useParams } from 'react-router-dom';

// export default AnimatedWrapper;
const AnimatedWrapperNoAnimatedWorkaround = WrappedComponent => (...props) => {
  const params = useParams();
  return <WrappedComponent location={location} match={{params}} {...props} isAnimationEnded={true} />;
}

export default AnimatedWrapperNoAnimatedWorkaround;